export function shortenString(text: string, length: number): string {
  let shortened: string = text

  if (text.length > length) {
    shortened = text.substring(0, length) + '...'
  }

  return shortened
}
